var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveViewTable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 64.76,
    y1: 78.2,
    x2: 141.32,
    y2: 78.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: 162.88,
    x2: 365.24,
    xlinkHref: "#ds"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.76,
    y: 39.56,
    width: 300.48,
    height: 350.88,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 45.56,
    width: 288.48,
    height: 338.88,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m353.24,313.16h-178.36c-6.62,0-12,5.38-12,12v53.28c0,6.62,5.38,12,12,12h178.36c6.62,0,12-5.38,12-12v-53.28c0-6.62-5.38-12-12-12Zm-166.36,53.28v-29.28h154.36v29.28h-154.36Z",
    fill: "#f7f7f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m365.24,143c0-6.62-5.38-12-12-12h-178.36c-6.62,0-12,5.38-12,12v53.28c0,6.62,5.38,12,12,12h178.36c6.62,0,12-5.38,12-12v-53.28Zm-178.36,41.28v-29.28h154.36v29.28h-154.36Z",
    fill: "#f7f7f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m365.24,234.44c0-6.62-5.38-12-12-12h-178.36c-6.62,0-12,5.38-12,12v53.28c0,6.62,5.38,12,12,12h178.36c6.62,0,12-5.38,12-12v-53.28Zm-178.36,41.28v-29.28h154.36v29.28h-154.36Z",
    fill: "#f7f7f7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m64.76,287.72c0,6.62,5.38,12,12,12h52.56c6.62,0,12-5.38,12-12v-53.28c0-6.62-5.38-12-12-12h-52.56c-6.62,0-12,5.38-12,12v53.28Zm52.56-41.28v29.28h-28.56v-29.28h28.56Z",
    fill: "#f7f7f7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m64.76,196.28c0,6.62,5.38,12,12,12h52.56c6.62,0,12-5.38,12-12v-53.28c0-6.62-5.38-12-12-12h-52.56c-6.62,0-12,5.38-12,12v53.28Zm52.56-41.28v29.28h-28.56v-29.28h28.56Z",
    fill: "#f7f7f7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m64.76,378.44c0,6.62,5.38,12,12,12h52.56c6.62,0,12-5.38,12-12v-53.28c0-6.62-5.38-12-12-12h-52.56c-6.62,0-12,5.38-12,12v53.28Zm52.56-41.28v29.28h-28.56v-29.28h28.56Z",
    fill: "#f7f7f7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m141.32,104.84v-53.28c0-6.62-5.38-12-12-12h-52.56c-6.62,0-12,5.38-12,12v53.28c0,6.62,5.38,12,12,12h52.56c6.62,0,12-5.38,12-12Zm-24-41.28v29.28h-28.56v-29.28h28.56Z",
    fill: "url(#ds)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m162.88,51.56v53.28c0,6.62,5.38,12,12,12h178.36c6.62,0,12-5.38,12-12v-53.28c0-6.62-5.38-12-12-12h-178.36c-6.62,0-12,5.38-12,12Zm24,41.28v-29.28h154.36v29.28h-154.36Z",
    fill: "url(#dt)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveViewTable);
export default __webpack_public_path__ + "static/media/drive_view_table.2e1a2b0312ddaa62d213d4c4b60a571d.svg";
export { ForwardRef as ReactComponent };